import Vue from 'vue';
import Router from 'vue-router';
import Home from './pages/Home.vue';
import InfoDocs from './pages/Help.vue';
import LogIn from './pages/LogIn.vue';
import SignUp from './pages/SignUp.vue';
import store from './store';

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/help',
      name: 'help',
      component: InfoDocs
    },
    {
      path: '/login',
      name: 'login',
      component: LogIn
    },
    {
      path: '/sign-up',
      name: 'signup',
      component: SignUp
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired)) {
      if (!store.state.isAuthenticated) {
          next({
              path: '/login'
          });
      } else {
          next();
      }
  } else {
      next();
  }
});

export default router;